<template>
    <div>
        <div  class="bg-white pb-6"  style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; height: auto;">
            <div class="fs-14 fw-500 px-8 bg-color py-2 mb-4">Call Report Info</div>
            <div  class="d-flex justify-content-between align-items-center px-8">
                <div>
                    <span class="fw-600 fs-14">List of Call Report attached with this Meetings:</span>
                </div>
                <div class="dropdown"  v-if="userPermissions.call_reports.permitted_actions.create || userPermissions.draft_call_reports.permitted_actions.create">
                    <a class="btn btn-new-primary btn-wide dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Add New Call Report
                    </a>
                    <div class="dropdown-menu call-report-type-menu" aria-labelledby="dropdownMenuLink">
                        <!-- <a class="dropdown-item" v-for="(category, index) in call_report_category_options"
                            :key="index" v-on:click="createCallReport(category)">{{ category }}</a> -->
                        <a class="dropdown-item" v-on:click="createCallReport('External Meeting')">External Meeting</a>
                        <a class="dropdown-item" v-on:click="createCallReport('Internal Meeting')">Internal Meeting</a>
                        <a class="dropdown-item" v-on:click="createCallReport('Review Meeting')">Review Meeting</a>
                        <a class="dropdown-item" v-on:click="createCallReport('Sales Meeting')">Sales Meeting</a>
                    </div>
                    
                </div>
                <!-- <div>
                    <button class="btn btn-new-primary btn-wide px-6" >Add To New Call Report</button>
                </div> -->
            </div>
            <div class="table-block overflow-x-auto mt-1 px-8 py-4" style="background-color:#fff;border-radius:5px">
                <!-- <div class="header-outer" v-if="!ajaxCallInProgress && teams.length == 0">
                    <span class="fw-500" v-if="teamLogin == 'My Team'">My Team</span>
                    <span class="fw-500" v-if="teamLogin == 'Team Member'">Team Member</span>
                </div> -->
                <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100" style="height: 500px">
                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
                <!-- Table List View -->
                <table v-else class="schedule-list-table table-responsive w-100">
                    <thead >
                        <tr>
                            <th width="15%">REPORT ID</th>
                            <th width="15%">COMPANY NAME</th>
                            <th width="15%">RECEIVER</th>
                            <th width="20%">RECEIVER TYPE</th>
                            <th width="20%">TITLE NAME</th>
                            <th width="20%">TIMESTAMP</th>
                            <th width="15%">AUTHOR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!ajaxCallInProgress && sentCallReportList.length == 0">
                            <td colspan="15">
                                <div class="text-center"> No Call Report added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(callreport,cl_index) in sentCallReportList" :key="cl_index">
                            <td width="15%" class="pointer" @click="viewSendCallReport(callreport._id)">
                                <span style="color: #00448b;">{{callreport.call_report_number.value}}</span>
                            </td>
                            <td width="15%">
                                <template v-for="(receiver,company_index) in callreport.receiver_company_details" >
                                    <div v-if="receiver.length >= 1" class="d-flex align-items-center" :key="company_index+receiver" >
                                        <span class="text-capitalize text-truncate" style="max-width: 200px;" :title="receiver[0]">{{receiver[0] || "-"}}</span>
                                        <br/>
                                        <el-popover
                                            v-if="receiver.length > 1"
                                            placement="bottom"
                                            trigger="hover">
                                            <div>
                                                <span class="fw-500">{{receiver.join(", ")}}</span>
                                            </div>
                                            <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                <div class="fw-500 mt-4px text-center text-secondary">
                                                    +{{receiver.length - 1}} more
                                                </div>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </template>
                            </td>
                            <td width="10%">
                                <template v-for="(receiver,index) in callreport.receiver_details" >
                                    <div v-if="receiver.length >= 1" class="d-flex align-items-center" :key="index+receiver" >
                                        <span v-if="receiver.length >= 1" class="text-capitalize text-truncate"  style="max-width: 100px;" :title="receiver[0]">{{receiver[0]}}</span>
                                        <span v-else class="text-capitalize">{{"-"}}</span>
                                        <br/>
                                        <el-popover
                                            v-if="receiver.length > 1"
                                            placement="bottom"
                                            trigger="hover">
                                            <div>
                                                <span class="fw-500">{{receiver.join(", ")}}</span>
                                            </div>
                                            <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                <div class="fw-500 mt-4px text-center text-secondary">
                                                    +{{receiver.length - 1}} more
                                                </div>
                                            </el-button>
                                        </el-popover>
                                    </div>
                                </template>
                            </td>
                            <td width="13%">
                                <span>{{callreport.receiver_type.value}}</span>
                            </td>
                            <td width="12%">
                                <span>{{callreport.title_name.value}}</span>
                            </td>
                            <td width="20%">
                                <span>{{callreport.timestamp.value || "-"}}</span>
                            </td>
                            <td width="15%">
                                <span>{{callreport.author.value}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="!ajaxCallInProgress" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                    :options="pageLimit" :close-on-select="true" v-model.number="limit" @select="getMeetingData"
                    :max-height="210" :allow-empty="false" :searchable="false"
                    open-direction="top" :show-labels="false" placeholder=""
                    style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-6 fw-500 text-dark font-size-small">Per page</span>
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import schedule from "../mixins/scheduleMeeting.js"
    import callreport from "../mixins/callreport";
    import { HalfCircleSpinner } from "epic-spinners";
    export default {
    data(){
        return{
            success_msg: '',
            warning_msg: "",
            limit: 10,
            skip: 0,
            pageLimit: [],
            total: 0,
            skip_temp:0,
            temp_total:0,
            count: 0,
            sentCallReportList: [],
            meeting_id: "",
            meeting_details:[],
            ajaxCallInProgress: false,
            call_report_ids: [],
            ajaxMeetingProgress: false
        }
    },
    mixins:[callreport, schedule],
    components: {HalfCircleSpinner},
    methods: {
        viewSendCallReport(callReport_id) {
            if(this.userPermissions.call_reports.permitted_actions.view || this.userPermissions.draft_call_reports.permitted_actions.view){
                this.$router.push("/viewcallreport/" + callReport_id);
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
        },
        async getMeetingData(){
            this.ajaxCallInProgress = true
            let params = {
                id: this.$route.params.id
            }
            let response = await this.getScheduleMeetingById(params)
            this.meeting_details = response.response
            this.call_report_ids = this.meeting_details.call_reports
            if(this.meeting_details.call_reports == null){
                this.ajaxCallInProgress = false
                this.sentCallReportList.length == 0
            }else{
                this.getCallReportList();
            }
            // this.ajaxCallInProgress = false
        },
        createCallReport(category) {
            this.meeting_id = this.$route.params.id
            this.$store.commit("setCallReportCategory", category);
            localStorage.setItem('meeting_id', JSON.stringify(this.meeting_id))
            if(this.$route.params.module_type == 'contacts' || this.$route.params.module_type == 'customers' || this.$route.params.module_type == 'leads' ){
                this.$router.push('/callreports/new/'+this.$route.params.module_type+'/'+this.$route.params.module_id);
            }else{
                this.$router.push('/callreport/new')
            }
        },
        async getCallReportList(param) {
            try {
                this.ajaxCallInProgress = true;
                this.sentCallReportList = [];
                let params = {
                    search_key: "",
                    limit: this.limit == '' || 0 || null || undefined ? 9 : this.limit,
                    skip: this.skip,
                    filter_json: {
                        "call_report_id": this.call_report_ids ? this.call_report_ids : ""
                    },
                };
                //Api call of the completed call report and passing all the data  as params
                let res = await this.getCallReportsList(params);
                this.sentCallReportList = res.response;
                this.sentCallReportList.forEach((x, index) => {
                    let company_name = x.receiver_details.company_name
                    if(typeof(x.receiver_details.company_name) == 'object'){
                        if(x.receiver_details.company_name.length == 0){
                            company_name = "-"
                        } else {
                            company_name = x.receiver_details.company_name
                        }
                    } else {
                        company_name = x.receiver_details.company_name
                    }
                    let data = x.receiver_details.name
                    let status = x.receiver_details.status
                        x.call_report_number = {
                            value: x.call_report_number || "-",
                            order: 1,
                        };
                        x.receiver_details = {
                            value: data || "-" ,
                            order: 2,
                        };
                        x.receiver_type ={
                            value: x.receiver_type || "-" ,
                            order: 3,
                        };
                        x.call_report_type = {
                            value: x.call_report_type || "-",
                            order: 4,
                        }
                        x.status = {
                            value: status || "-",
                            order: 5,
                        };
                        x.title_name = {
                            value: x.title || "-",
                            order: 6,
                        };
                        x.timestamp = {
                            value: x.timestamp || "-",
                            order: 7,
                        };
                        x.author ={
                            value: x.author_name || "-",
                            order: 8,
                        };
                        x.receiver_company_details = {
                            value: company_name || "-" ,
                            order: 9,
                        };
                });
                this.total = res.total
                this.$forceUpdate();

                this.ajaxCallInProgress = false;
            }
            catch(err){
                this.ajaxCallInProgress = false;
            }
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.skip_temp = 0
            this.getCallReportList()
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getCallReportList()
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getCallReportList()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getCallReportList()
        },
    },
    mounted(){
        this.getMeetingData();
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        
    },
    created() {
       
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
    },
}
</script>
<style>
    .bg-color{
        background-color: #00448b;
        color:#fff !important;
        border-radius: 4px;
    }
    .schedule-list-table thead tr{
        width: 100% !important;
    }
    .schedule-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 10px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .schedule-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .schedule-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .schedule-list-table tbody tr td {
        background: #fff;
        padding: 10px 10px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .schedule-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/CallReportTab.vue